module.exports = __webpack_public_path__ + "static/media/check.ca5e828c.svg";